<!--  -->
<template>
  <div>
    <div class="chat_box">
      <div class="personnel_box">
        <div class="left_peole_box">
          <div v-for="item,index in personnelarrrw" :key="index" class="left_itempeole_box" :class="[item.tips?'active_box ':'']" @click="choose(item)">
            <img v-if="item.avatar!=''" :src="item.avatar" class="personneimg">
            <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" class="personneimg" alt="">
            <div class="name_box"><div class="name_boxsize">{{ item.name }}</div><div class="corpname_box">({{ corp_name }})</div>
            </div>
          </div>
        </div>
        <div>
          <div><el-input v-model="query.nickname" placeholder="请输入客户" size="mini" @input="goSearch" /></div>
          <div class="tab_box">
            <el-radio-group v-model="radiotype" size="mini">
              <el-radio-button :label="1">人员</el-radio-button>
              <el-radio-button :label="2">群组</el-radio-button>
            </el-radio-group>
          </div>
          <div ref="staff_allboxview" v-loading="loadinglink" element-loading-background="transparent" class="left_peole_box" style="height: 742px;" @scroll="scrollEvent">
            <div v-for="item,index in customarr" :key="index" class="left_itempeole_box" :class="[item.tips?'active_box ':'']" @click="choosekehu(item)">
              <!-- <img :src="item.avatar" class="personneimg"> -->
              <img :src="item.avatar===''?nativepic:item.avatar" class="personneimg">
              <el-badge v-if="item.unread_message_count !== undefined&&item.unread_message_count >0&&!item.show" :value="`${item.unread_message_count}`" class="itembadge" />
              <div class="name_box">
                <div class="name_boxsize">{{ item.nickname }}</div>
              </div>
              <div style="margin-left:3px">
                <i v-if="item.gender === 1" class="el-icon-male" style="color:#36a9e0" />
                <i v-else class="el-icon-female" style="color:#ff77c3" />
              </div>
              <div v-if="item.type === 2" style="color:#E6A23C">@企业客户</div>
            </div>
          </div>
        </div>
        <div v-show="currentStep === false" class="talk_box">
          <div class="top_userbox">
            <img :src="groupitem.avatar===''?'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png':groupitem.avatar" alt="" class="top_userimg">
            <div class="top_name_box">{{ groupitem.nickname }}</div>
            <div style="margin-left:3px">
              <i v-if="groupitem.gender === 1" class="el-icon-male" style="color:#36a9e0" />
              <i v-else class="el-icon-female" style="color:#ff77c3" />
            </div>
            <div v-if="complain!=1" style="margin-left: 50px;">小程序发送人设置：</div>
            <div v-if="complain!=1" style="position: relative; display: inline-block;margin-left: 10px;">
              <el-switch
                v-model="groupitem.receive_miniprogram"
                :width="80"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                @change="statusChange"
              />
              <div
                v-if="groupitem.receive_miniprogram === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >已设置</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >未设置</div>
            </div>
            <div style="margin-left: 50px;">接粉号:</div>
            <div style="position: relative; display: inline-block;margin-left: 10px;">
              <el-switch
                v-model="groupitem.accept_business_card"
                :width="80"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                @change="statusChangetwo"
              />
              <div
                v-if="groupitem.accept_business_card === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >已设置</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >未设置</div>
            </div>
            <div>
              <!-- <el-date-picker
                v-model="date"
                style="width: 240px;margin-left: 10px;"
                type="daterange"
                align="right"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              /> -->
              <el-date-picker
                v-model="date"
                type="date"
                style="width: 150px;margin-left: 10px;"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="handleDateChange"
              />
            </div>
          </div>
          <div
            ref="talk_allboxview"
            class="talk_allbox"
            @scroll="handleScroll"
            @mousedown="handleMouseDown"
            @mouseup="handleMouseUp"
            @mousemove="handleMouseMove"
          >
            <div v-for="item,indexr in talkarr" :key="indexr">
              <div v-if="typeof item.push_time === 'number' && item.initiator_is_me === 0" style="max-width: 12.5rem;  " class="container">
                <span style="margin:0.5rem 0 0rem 0.8rem;">{{ item.formattedDate }}</span>
              </div>
              <div v-if="item.initiator_is_me === 0" style="display: flex;align-items: center;margin-top:0.5rem;position: relative;margin-left: 0.5rem;">
                <img style="width: 2.8rem;height:2.8rem" :src="groupitem.avatar===''?'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png':groupitem.avatar" alt="">
                <!-- <div style="display: flex;flex-direction: column-reverse;"> -->

                <div v-if="item.message_type === 'sp_text'" class="talk_name">{{ item.sp_text.content }}</div>
                <div v-if="item.message_type === 'sp_image'" class="talk_name">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.sp_image.href"
                    :fit="fits"
                    :preview-src-list="[item.sp_image.href]"
                  />
                </div>
                <div v-if="item.message_type === 'sp_link'" class="talk_nametuwe">
                  <div class="title_box">{{ item.sp_link.title }}</div>
                  <div class="content_box">
                    <div class="content_text">{{ item.sp_link.desc }}</div>
                    <img style="width:50px;height:50px" :src="item.sp_link.cover_url" alt="">
                  </div>
                </div>

                <div v-if="item.message_type === 'sp_miniprogram'" class="talk_wecaht">
                  <div class="car_home">
                    <img class="car_title" :src="item.sp_miniprogram.weappiconurl" alt="">
                    <div>{{ item.sp_miniprogram.des_1 }}</div>
                  </div>
                  <div class="car_content">
                    {{ item.sp_miniprogram.title }}
                  </div>
                  <div>
                    <img class="car_contenimg" :src="item.sp_miniprogram.thumburl" alt="">
                  </div>
                  <div class="wecaht_line" />
                  <div class="wechat_weaer">
                    <img class="wechat_icon" src="https://img0.baidu.com/it/u=2727472462,3456339228&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500" alt="">
                    <div>小程序</div>
                  </div>
                </div>
                <!-- </div> -->
              </div>

              <div v-if="item.initiator_is_me === 1" style="display: flex;align-items: center;margin-top:0.5rem;position: relative;justify-content: end;">

                <div v-if="item.send_status === 1">
                  <i class="el-icon-question" style="color:#e6a23c;font-size:18px" />
                </div>
                <div v-if="item.send_status === 2">
                  <i class="el-icon-success" style="color:#85ce61;font-size:18px" />
                </div>
                <div v-if="item.send_status === 3">
                  <i class="el-icon-warning" style="color:#f78989;font-size:18px" />
                </div>
                <div style="display: flex;flex-direction: column;">
                  <div v-if="typeof item.push_time === 'number' && item.initiator_is_me === 1" style="max-width: 43.6rem " class="container">
                    <span style="margin-left: 0.8rem;">{{ item.formattedDate }}</span>
                  </div>
                  <div v-if="item.message_type === 'sp_text'" class="yourtalk">{{ item.sp_text.content }}</div>
                  <div v-if="item.message_type === 'sp_image'" class="talk_name">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.sp_image.href"
                      :fit="fits"
                      :preview-src-list="[item.sp_image.href]"
                    />
                  </div>
                  <div v-if="item.message_type === 'sp_link'" class="talk_nametuwe">
                    <div class="title_box">{{ item.sp_link.title }}</div>
                    <div class="content_box">
                      <div class="content_text">{{ item.sp_link.desc }}</div>
                      <img style="width:50px;height:50px" :src="item.sp_link.cover_url" alt="">
                    </div>
                  </div>
                  <div v-if="item.message_type === 'sp_miniprogram'" class="talk_wecaht">
                    <div class="car_home">
                      <img class="car_title" :src="item.sp_miniprogram.weappiconurl" alt="">
                      <div>{{ item.sp_miniprogram.des_1 }}</div>
                    </div>
                    <div class="car_content">
                      {{ item.sp_miniprogram.title }}
                    </div>
                    <div>
                      <img class="car_contenimg" :src="item.sp_miniprogram.thumburl" alt="">
                    </div>
                    <div class="wecaht_line" />
                    <div class="wechat_weaer">
                      <img class="wechat_icon" src="https://img0.baidu.com/it/u=2727472462,3456339228&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500" alt="">
                      <div>小程序</div>
                    </div>
                  </div>
                </div>
                <img v-if="staffitem.avatar === ''" style="width: 2.8rem;height:2.8rem;margin: 0rem 0.5rem 0rem 0.5rem;" src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" alt="">
                <img v-else style="width: 2.8rem;height:2.8rem;margin: 0rem 0.5rem 0rem 0.5rem;" :src="staffitem.avatar" alt="">
              </div>
            </div>

          </div>
          <div class="bottom_talk">
            <el-input v-model="content" class="bottom_input" placeholder="请输入内容" />
            <div class="line" />
            <img v-if="content===''" class="img_box" src="https://ziyuan.jingxuansz.com/user/yd5vj5-230426175742705861.png" alt="">
            <img v-else class="img_box" src="https://ziyuan.jingxuansz.com/user/m0qnn7-230426175834253780.png" alt="" @click="send">
            <el-tooltip class="item" effect="dark" content="图片" placement="top">
              <i class="el-icon-picture-outline add_box" @click="handleCommand('a')" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="图文" placement="top">
              <i class="el-icon-edit-outline add_boxr" @click="handleCommand('b')" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="小程序" placement="top">
              <img class="add_boxrr" src="https://img0.baidu.com/it/u=2727472462,3456339228&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500" alt="小程序" srcset="" @click="handleCommand('c')">
            </el-tooltip>
            <!-- <img src="" alt=""> -->
            <!-- <el-dropdown trigger="click" class="add_box" @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="el-icon-circle-plus-outline" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-picture" command="a">图片</el-dropdown-item>
                <el-dropdown-item icon="el-icon-picture-outline" command="b">图文</el-dropdown-item>
                <el-dropdown-item icon="el-icon-s-comment" command="c">小程序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->

          </div>

        </div>
        <div v-show="currentStep === true" class="talk_boxr">
          <div class="no_talk">
            <img src="https://ziyuan.jingxuansz.com/user/gh59dk-230426160435602252.png" alt="">
            <div>对伙伴的夸赞,需要大声说出口</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <!-- 图文弹窗 -->
    <el-dialog
      title="选择图文"
      :visible.sync="dialogVisibletu"
      :close-on-click-modal="false"
      width="25%"
      append-to-body
      :destroy-on-close="true"
    >
      <edittuwen ref="tuwenview" @callback="callback" />
    </el-dialog>
    <!-- 小程序弹窗 -->
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisiblewecaht"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <wechat ref="wechatview" @wechatcallback="wechatcallback" />
    </el-dialog>
  </div>
</template>

<script>// upToolChatRecord
import { getFriendList, sendMessage, chatRecord, setReceiveMiniprogramFriend, setReceiveEmployee } from '@/api/officialaccount.js'
import chooseimg from '../../menumanagement/components/chooseimg.vue'
import edittuwen from '../components/edittuwen.vue'
import wechat from './wechat.vue'
export default {
  components: { chooseimg, edittuwen, wechat },
  data() {
    return {
      nativepic: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
      personnelarr: [
        // {
        //   name: '张三',
        //   id: 1,
        //   img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F09%2F20210609081952_51ef5.thumb.1000_0.jpg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1685068687&t=7b8926fd4017836abb71fbcc08f12e6d',
        //   tips: false
        // },
        // {
        //   name: '李四1',
        //   id: 2,
        //   img: 'https://img2.baidu.com/it/u=1579991524,66947472&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500',
        //   tips: false
        // }
      ],
      personnelarrrw: [],
      customarr: [
        // {
        //   name: '张三客户',
        //   id: 1
        // }
      ],
      talkarr: [
        // {
        //   type: 1,
        //   talkname: '哈哈哈111111111111112222222223',
        //   content_type: 1
        // },
      ],
      id: 2,
      content: '',
      fits: 'scale-down',
      corp_name: '',
      query: {
        nickname: '', // 搜索的姓名
        page: 1,
        page_size: 20
      },
      radiotype: 1, // 客户人员类型
      staffitem: {}, // 当前点击员工对象
      groupitem: {}, // 当前客户或者群组对象
      statu: true, // 搜索防抖
      loadinglink: false, // 客服人员列表loading
      currentStep: true,
      dialogVisible: false,
      dialogVisibletu: false,
      dialogVisiblewecaht: false,
      // 是否加载中
      tableLoading: false,
      tableCount: null,
      talktotal: null,
      cursor: '',
      alwer: null,
      complain: null,
      wx_id: null,
      bottoming_out: null,
      isMouseDown: false,
      date: '',
      dates: '',
      pickerOptions: {
        disabledDate(time) {
          const today = new Date() // 获取当前日期
          today.setHours(0, 0, 0, 0) // 将时间设为0点
          return time.getTime() > today.getTime() // 比较时间判断是否禁用
        }
      }
    }
  },
  computed: {
    // currentStep: {
    //   get() {
    //     return this.customarr.every(function(item) {
    //       return item.tips !== false
    //     })
    //   },
    //   set() {
    //   }
    // }
  },
  created() {
    window.addEventListener('keydown', this.handkeyCode, true)
  },
  mounted() {
    console.log('222222')
    this.$nextTick(() => {
      this.$refs.talk_allboxview.addEventListener('scroll', this.scroll)
      // this.$refs.staff_allboxview.addEventListener('scroll', this.scrollr)
    })
  },
  methods: {
    handleDateChange(e) {
      this.dates = ''
      this.cursor = ''
      if (!this.dates) {
        this.talkarr = []
      }
      if (this.date === null) {
        this.chatRecordlist(1, this.infoitem)
        return
      }
      this.dates = this.date.replace(/-/g, '')
      this.cursor = ''
      // const selectedDate = new Date(this.date).getDate()
      // const currentDate = new Date().getDate()
      // if (selectedDate === currentDate) {
      //   this.dates = ''
      // }
      this.chatRecordlist(1, this.infoitem)
    },
    handleMouseDown() {
      console.log('鼠标按下')
      this.isMouseDown = true
    },
    handleMouseUp() {
      console.log('鼠标松开')
      this.isMouseDown = false
    },
    handleMouseMove(event) {
      if (this.isMouseDown && event.clientY > this.lastClientY) {
        console.log('鼠标下滑')
        this.add() // 在鼠标下滑时调用add函数
        this.isMouseDown = false
      }
      this.lastClientY = event.clientY // 记录当前鼠标位置
    },
    handleScroll(event) {
      console.log(event)
      const scrollTop = event.target.scrollTop
      const scrollHeight = event.target.scrollHeight
      const clientHeight = event.target.clientHeight

      if (scrollTop + clientHeight >= scrollHeight) {
        console.log('发生下拉')
        // 触发自定义事件或其他操作
      }
    },
    add() {
      if (this.cursor === '') {
        this.cursor = 0
      }
      this.cursor--
      this.chatRecordlist(1, this.infoitem)
    },
    formatTimestamp(timestamp) {
      var date = new Date(timestamp * 1000) // 将时间戳转换为毫秒级别
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var day = ('0' + date.getDate()).slice(-2)
      var hours = ('0' + date.getHours()).slice(-2)
      var minutes = ('0' + date.getMinutes()).slice(-2)
      var seconds = ('0' + date.getSeconds()).slice(-2)
      var formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      return formattedDate
    },
    sendr(item, type, complain) {
      this.complain = complain
      this.wx_id = item.wx_id
      this.$nextTick(() => {
        document.getElementsByClassName('talk_allbox')[0].scrollTo({ top: document.getElementsByClassName('talk_allbox')[0].scrollHeight, behavior: 'smooth' })
      })
      this.corp_name = item.corp_name
      console.log(item)
      const newUsers = sessionStorage.getItem('arr')
      // console.log('newUsers', newUsers)
      if (newUsers === null) {
        sessionStorage.setItem('arr', JSON.stringify([]))
        const newUsersr = JSON.parse(sessionStorage.arr)
        this.personnelarr = newUsersr
      } else {
        const newUsersrs = JSON.parse(sessionStorage.arr)
        this.personnelarr = newUsersrs
      }
      if (this.personnelarr.length === 0) {
        item.tips = true
        this.personnelarr.push(item)
        this.staffitem = item
      } else {
        this.reastcalir()
        const indexs = this.personnelarr.findIndex(itemr => {
        // eslint-disable-next-line eqeqeq
          return itemr.employee_no == item.employee_no
        })
        if (indexs === -1) {
          console.log('没找到', item)
          item.tips = true
          this.personnelarr.unshift(item)
          this.staffitem = item
        } else {
          this.staffitem = this.personnelarr[indexs]
          this.personnelarr[indexs].tips = true
          this.personnelarr.unshift(this.personnelarr.splice(indexs, 1)[0])
          this.$forceUpdate()
          console.log('找到了', this.personnelarr[indexs], this.personnelarr)
        //  this.personnelarr[indexs].type_name
        }
      }
      if (type === 2) {
        this.query.nickname = item.external_user_name
        // this.staffitem.employee_no = item.employee_no
        const obj = {
          nickname: item.external_user_name,
          friend_id: item.friend_id,
          avatar: item.external_user_avatar,
          gender: item.gender
        }
        this.groupitem = obj
        this.currentStep = false
        this.chatRecordlist(1)
      }
      this.customlist()
      sessionStorage.setItem('arr', JSON.stringify(this.personnelarr))
      const newUsersr = JSON.parse(sessionStorage.arr)
      // console.log('newUsers', newUsers)
      this.personnelarrrw = []
      this.personnelarrrw = newUsersr
    },
    async customlist() {
      this.loadinglink = true
      this.tableLoading = true
      if (this.complain === 1) {
        const data = await getFriendList({
          employee_no: this.staffitem.employee_no,
          ...this.query,
          complain: true
        })
        // this.customarr = data.data.list
        this.customarr = this.customarr.concat(data.data.list)
        this.tableCount = data.data.total
        this.bottoming_out = data.data.bottoming_out
        this.customarr.forEach((item) => {
          item.tips = false
          if (Object.keys(this.groupitem).length !== 0) {
            if (item.friend_id === this.groupitem.friend_id) {
              item.tips = true
            }
          }
        })
        this.loadinglink = false
        this.tableLoading = false
        console.log('data', data)
      } else {
        const data = await getFriendList({
          employee_no: this.staffitem.employee_no,
          ...this.query
        })
        // this.customarr = data.data.list
        this.customarr = this.customarr.concat(data.data.list)
        this.tableCount = data.data.total
        this.bottoming_out = data.data.bottoming_out
        this.customarr.forEach((item) => {
          item.tips = false
          if (Object.keys(this.groupitem).length !== 0) {
            if (item.friend_id === this.groupitem.friend_id) {
              item.tips = true
            }
          }
        })
        this.loadinglink = false
        this.tableLoading = false
        console.log('data', data)
      }
    },
    goSearch() {
      // 保持this的指向始终指向vue实例
      const that = this
      if (!that.statu) {
        return
      }
      that.statu = false
      setTimeout(function() {
        console.log(new Date())
        that.query.page = 1
        that.customarr = []
        that.customlist() // 调用写好的方法
        that.statu = true
      }, 1000)
    },
    // 重置
    reastcalir() {
      this.personnelarr.forEach((item) => {
        item.tips = false
      })
    },
    zhidi() {
      this.$nextTick(() => {
        document.getElementsByClassName('talk_allbox')[0].scrollTo({ top: document.getElementsByClassName('talk_allbox')[0].scrollHeight, behavior: 'smooth' })
      })
    },
    fullName() {
      return this.customarr.every(function(item) {
        return item.tips === true
      })
    },
    choose(item) {
      this.cursor = ''
      this.query.nickname = ''
      this.talkarr = []
      this.groupitem = {}
      this.query.page = 1
      this.customarr = []
      this.staffitem = item
      this.customlist()
      this.personnelarrrw.forEach(item => {
        item.tips = false
      })
      item.tips = true
      this.customarr.forEach(item => {
        item.tips = false
      })
      this.currentStep = true
    },
    choosekehu(item) {
      this.dates = ''
      item.show = true
      console.log('item-------', item)
      this.customarr.forEach(item => {
        item.tips = false
      })
      item.tips = true
      this.groupitem = item
      this.currentStep = false
      // this.$forceUpdate()
      this.cursor = ''
      this.talkarr = []
      this.talktotal = null
      this.chatRecordlist(1, item)
      this.infoitem = item
      this.alwer = 1
    },
    async chatRecordlist(type, item) {
      const data = await chatRecord({
        employee_no: this.staffitem.employee_no,
        friend_id: this.groupitem.friend_id,
        // cursor: this.talkarr.length === 0 ? this.cursor : this.talkarr[0].id,
        cursor: this.cursor,
        direction: this.talkarr.length === 0 ? '' : 'up',
        date: this.dates,
        unread_message_count: item.unread_message_count
      })
      // this.date = ''
      // this.dates = ''
      console.log(data, '-------data')
      if (data.data === null) {
        this.$message({
          type: 'success',
          message: '请求数据为空 请求下一天'
        })
        return
      }
      this.talktotal = null
      this.talktotal = data.data.total
      if (data.data.list.length === 0) {
        this.talkarr = []
      } else {
        if (this.talkarr.length === 0) {
          console.log(11111212121121)
          this.talkarr = JSON.parse(data.data.list[0].content)
          // this.talkarr = data.data.list.reverse()
        } else {
          console.log(333333)
          JSON.parse(data.data.list[0].content).forEach((items) => {
            this.talkarr.unshift(items)
          })
        }
      }
      if (type === 1) {
        this.zhidi()
      }
      this.talkarr.forEach(v => {
        if (v.push_time) {
          console.log(v.push_time, 'v.push_time')
          v.formattedDate = this.formatTimestamp(v.push_time)
        }
      })
      // console.log(this.talkarr, item.wx_id, JSON.parse(data.data.list[0].content), 'this.talkarr----99999-- ')
      if (item.wx_id) {
        this.talkarr.forEach(items => {
        // console.log(item.initiator_is_me, 'send_status')
          if (items.initiator_wx_id === item.wx_id) {
            items.initiator_is_me = 1
          } else {
            items.initiator_is_me = 0
          }
        })
      }

      console.log('data9999999999999---------', this.talkarr)
    },
    async sendall(type, obj) {
      const data = await sendMessage({
        employee_no: this.staffitem.employee_no,
        target_type: this.radiotype,
        target_id: this.groupitem.friend_id,
        msg_type: type,
        msg_data: obj
      })
      this.zhidi()
      console.log('data', data)
    },
    async chatRecordlistr() {
      const data = await chatRecord({
        employee_no: this.staffitem.employee_no,
        friend_id: this.groupitem.friend_id,
        cursor: '',
        direction: ''
      })
      this.talkarr = []
      this.cursor = ''
      this.talktotal = data.data.total
      if (data.data.list.length === 0) {
        this.talkarr = []
      } else {
        console.log('46564--------------------------------------', data, this.talkarr)
        if (this.talkarr.length === 0) {
          this.talkarr = JSON.parse(data.data.list[0].content)
          console.log('之后', this.talkarr)
          if (this.infoitem) {
            this.talkarr.forEach(items => {
              // console.log(item.initiator_is_me, 'send_status')
              if (items.initiator_wx_id === this.infoitem.wx_id) {
                items.initiator_is_me = 1
              } else {
                items.initiator_is_me = 0
              }
            })
          }
          // this.talkarr = data.data.list.reverse()
        } else {
          console.log('之前')

          // this.talkarr.unshift(...data.data.list)
          data.data.list.forEach((items) => {
            console.log('22222', items)
            this.talkarr.unshift(items)
          })
        }
      }
    },
    async send() {
      this.sendall('sp_text', {
        content: this.content
      })
      // this.talkarr.push({
      //   send_status: 1,
      //   initiator_is_me: 1,
      //   content: {
      //     message_type: 'sp_text',
      //     sp_text: {
      //       content: this.content
      //     }
      //   }
      // })
      setTimeout(() => {
        this.zhidi()
        this.chatRecordlistr()
      }, 1000)

      this.content = ''
    },
    async handkeyCode(e) {
      console.log(e) // 打印出按键后的信息
      if (this.content === '') {
        // this.$message.error('不能发送空消息')
        return
      }
      if (e.keyCode === 13 || e.keyCode === 32) {
        console.log('触发了回车/空格键')
        this.sendall('sp_text', {
          content: this.content
        })

        // this.talkarr.push({
        //   send_status: 1,
        //   initiator_is_me: 1,
        //   content: {
        //     message_type: 'sp_text',
        //     sp_text: {
        //       content: this.content
        //     }
        //   }
        // })
        setTimeout(() => {
          this.zhidi()
          this.chatRecordlistr()
        }, 1000)

        this.content = ''
        console.log(' this.talkarr', this.talkarr)
      }
    },
    scroll(e) {
      const scrollTop = e.target.scrollTop // 滑入屏幕滚动条滚动时，距离顶部的距离
      const windowHeitht = e.target.clientHeight // 能看到的页面的高度
      const scrollHeight = e.target.scrollHeight // 监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      const total = scrollTop + windowHeitht
      if (scrollTop === 0) {
        console.log(this.talkarr.length, this.talktotal)
        if (this.talkarr.length === this.talktotal) {
          return
        }

        // eslint-disable-next-line eqeqeq
        if (this.alwer != 1) {
          console.log('进来调用了', '11')
          if (this.cursor === '') {
            this.cursor = 0
          }
          this.cursor--
          this.chatRecordlist()
        }
        console.log('到顶了')
      }
      // eslint-disable-next-line eqeqeq
      if (total == scrollHeight) {
        console.log('到底了')
        // 加载操作
      } else {
        this.alwer = 2
        console.log('还没有到底')
      }
    },
    // scrollr(e) {
    //   const scrollTop = e.target.scrollTop // 滑入屏幕滚动条滚动时，距离顶部的距离
    //   const windowHeitht = e.target.clientHeight // 能看到的页面的高度
    //   const scrollHeight = e.target.scrollHeight // 监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
    //   const total = scrollTop + windowHeitht
    //   if (scrollTop === 0) {
    //     console.log('到顶了')
    //   }
    //   // eslint-disable-next-line eqeqeq
    //   if (total == scrollHeight) {
    //     console.log('到底了')
    //     if (!this.tableLoading) {
    //       this.tableLoading = true
    //       if (this.customarr.length < this.tableCount) {
    //         this.query.page++
    //         this.customlist()
    //       } else {
    //         // this.$message('已加载完所有的数据！')
    //         this.tableLoading = false
    //       }
    //     }
    //     // 加载操作
    //   } else {
    //     // console.log('还没有到底')
    //   }
    // },
    scrollEvent(e) {
      // console.log(e)
      console.log(e, e.srcElement.scrollTop, e.srcElement.clientHeight, e.srcElement.scrollHeight)
      // eslint-disable-next-line eqeqeq
      // if (e.srcElement.scrollTop + e.srcElement.clientHeight + 1 >= e.srcElement.scrollHeight) {
      //   if (!this.tableLoading) {
      //     this.tableLoading = true
      //     if (this.customarr.length < this.tableCount) {
      //       this.query.page++
      //       this.customlist()
      //     } else {
      //       // this.$message('已加载完所有的数据！')
      //       this.tableLoading = false
      //     }
      //   }
      //   console.log('嘿嘿我在底部触发了')
      // }
      // eslint-disable-next-line eqeqeq
      if (e.srcElement.scrollTop + e.srcElement.clientHeight + 1 >= e.srcElement.scrollHeight) {
        console.log('111')
        if (!this.tableLoading) {
          this.tableLoading = true
          console.log('111')
          // eslint-disable-next-line eqeqeq
          if (this.bottoming_out == false) {
            console.log('111')
            this.query.page++
            this.customlist()
          } else {
          // this.$message('已加载完所有的数据！')
            this.tableLoading = false
          }
        }
      }
    },
    handleCommand(val) {
      console.log('val', val)
      if (val === 'a') {
        this.dialogVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.mychild.parentHandleclick('1')
        }, 100)
        console.log('图片')
      } else if (val === 'b') {
        console.log('图文')
        this.dialogVisibletu = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.tuwenview.send({})
        }, 100)
      } else {
        console.log('小程序')
        this.dialogVisiblewecaht = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.wechatview.send()
        }, 100)
      }
    },
    clickicon(img, key) {
      this.dialogVisible = false
      // this.attachments[this.activeindex].image.source_material_id = key
      // this.attachments[this.activeindex].image.pic_url = img
      this.sendall('sp_image', {
        href: img
      })
      // this.talkarr.push({
      //   send_status: 1,
      //   initiator_is_me: 1,
      //   content: {
      //     message_type: 'sp_image',
      //     sp_image: {
      //       href: img
      //     }
      //   }
      // })

      setTimeout(() => {
        this.zhidi()
        this.chatRecordlistr()
      }, 2000)
    },
    callback(form) {
      this.dialogVisibletu = false
      this.sendall('sp_link', {
        title: form.title,
        cover_url: form.testsrc,
        desc: form.description,
        href: form.url
      })
      // this.talkarr.push({
      //   send_status: 1,
      //   initiator_is_me: 1,
      //   content: {
      //     message_type: 'sp_link',
      //     sp_link: {
      //       title: form.title,
      //       cover_url: form.testsrc,
      //       desc: form.description,
      //       href: form.url
      //     }
      //   }
      // })

      setTimeout(() => {
        this.zhidi()
        this.chatRecordlistr()
      }, 2000)
    },
    wechatcallback(item) {
      console.log('item', item)
      this.dialogVisiblewecaht = false
      this.sendall('sp_miniprogram', {
        app_id: item.app_id,
        title: item.title,
        desc: item.des_1,
        page_path: item.pagepath,
        miniprogram_no: item.miniprogram_no
      })
      setTimeout(() => {
        this.zhidi()
        this.chatRecordlistr()
      }, 2000)
      // this.talkarr.push({
      //   type: 2,
      //   app_id: item.app_id,
      //   title: item.title,
      //   desc: item.des_1,
      //   page_path: item.pagepath,
      //   weappiconurl: item.weappiconurl,
      //   content_type: 4
      // })
      // this.zhidi()
    },
    close() {
      console.log('111')
      // this.customarr.forEach(item => {
      //   item.tips = false
      // })
      this.query.nickname = ''
      this.query.page = 1
      this.cursor = ''
      this.talkarr = []
      this.customarr = []
      this.groupitem = {}
      this.currentStep = true
    },
    statusChange(val) {
      console.log('val', val)
      console.log(this.wx_id)
      console.log(this.groupitem)
      setReceiveMiniprogramFriend({
        wx_id: this.wx_id,
        friend_id: this.groupitem.friend_id,
        type: val === 1 ? 'setting' : 'unset'
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      })
    },
    statusChangetwo() {
      setReceiveEmployee({
        employee_no: this.staffitem.employee_no,
        friend_id: this.groupitem.friend_id
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        this.groupitem.accept_business_card = 2
      })
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chat_box{
  width: 100%;
  /* height: 600px; */
  height: 800px;
  background-color: white;
  border: 1px solid paleturquoise;
  border-radius: 10px;
}
.personneimg{
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
.left_peole_box{
  /* height: 595px; */
  height: 805px;
  width: 200px;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  flex-shrink: 0;
}
.left_itempeole_box{
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 6px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.active_box{
  background: #e6f0ff;
}
/* ::-webkit-scrollbar {
  width: 10px;
  height: 1px;
} */
.personnel_box{
  display: flex;
}
.left_peole_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #bbbcbe;
}
.left_peole_box::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: transparent;
  border-radius: 5px;
}
.name_box{
  margin-left: 10px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.name_boxsize{
  max-width: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.left_peole_box::-webkit-scrollbar{
    width: 0 ;
  height: 0;
}
.left_peole_box:hover::-webkit-scrollbar{
  width: 5px;
  height: 1px;
}
.talk_allbox::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}
.talk_allbox::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #bbbcbe;
}
.talk_allbox::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
}
.talk_box{
  position: relative;
  width: 100%;
  background: #fbfbfc;
  border-left: 1px solid #ebeced;
/* 新 */
  height: 100%;
}
.talk_allbox{
  /* height: 475px; */
  height: 676px;
  overflow-y: auto;
  padding-bottom: 10px;
}
.top_userbox{
  height: 65px;
  background: #fbfbfc;
  border-bottom: 1px solid #dadbdd;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  margin-bottom: 0.5rem;

    }
.top_userimg{
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.top_name_box{
  color: #1f2329;
  margin-left: 10px;
  font-size: 17px;
  font-weight: 600;
}
.no_talk{
  text-align: center;
}
.talk_boxr {
  width: 100%;
  background: #fbfbfc;
  display:flex;
  justify-content:center;
  align-items:center;
}
.bottom_talk{
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
}
.img_box{
  height: 23px;
  width: 23px;
  position: absolute;
  right: 28px;
  top: 11px;
}
.add_box{
  height: 23px;
  width: 23px;
  position: absolute;
  right: 62px;
  top: 12px;
  font-size: 19px;
}
.add_boxr{
  height: 23px;
  width: 23px;
  position: absolute;
  right: 87px;
  top: 12px;
  font-size: 19px;
}
.add_boxrr{
  width: 18px;
  position: absolute;
  right: 116px;
  top: 14px;
}
.line{
  height: 20px;
  width: 1px;
  background: #dddedf;
  position: absolute;
  right: 55px;
  top: 12px;
}
.bottom_input /deep/ .el-input__inner{
    width: 100%;
    height: 45px;
 }
 .talk_name{
    border: 1px solid #E8E8E8;
    max-width: 14rem;
    padding: 0.5rem;
    margin-left: 0.8rem;
    border-radius: 6px;
 }
 .talk_nametuwe{
    border: 1px solid #E8E8E8;
    max-width: 14rem;
    padding: 10px;
    margin-left: 0.8rem;
    border-radius: 6px;
 }
 .talk_wecaht{
    border: 1px solid #E8E8E8;
    max-width: 14rem;
    padding: 10px;
    margin-left: 0.8rem;
    border-radius: 6px;
 }
 .yourtalk{
    max-width: 14rem;
    padding: 0.5rem;
    margin-left: 0.5rem;
    border-radius: 6px;
    background-color:#c9e7ff;
 }
 .corpname_box{
    width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 }
 .content_box{
    display: flex;
    align-items: top;
    margin-top: 15px;
 }
 .content_text{
   width: 230px;
   height: 50px;
   overflow : hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 3;/*超出2行就显示省略号，可以填3或者其它正整数*/
 }
 .title_box{
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
 }
 .car_home{
  display: flex;
  align-items: center;
  width: 200px;
 }
 .car_title{
    height: 30px;
    width: 32px;
    border-radius: 50%;
    margin-right: 20px;
 }
 .car_content{
    width: 100%;
   height: 32px;
   overflow : hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;/*超出2行就显示省略号，可以填3或者其它正整数*/
   margin-top: 10px;
 }
 .car_contenimg{
  width:202px;
  height: 180px;
  margin-top: 10px;
 }
 .wecaht_line{
  width: 100%;
  height: 1px;
  background: #f0f0f0;
  margin-top: 5px;
 }
 .wechat_weaer{
  display: flex;
  align-items: center;
  margin-top: 5px;
 }
 .wechat_icon{
  width: 15px;
  height: 15px;
  margin-right: 5px;
 }
.tab_box /deep/ .el-radio-button--mini .el-radio-button__inner {
  padding: 7px 37px;
 }
.itembadge{
  position: absolute;
  top: 5px;
  left: 35px;
  /* left: -15px;
  top: -15px; */
}
</style>
